<template>
  <div class="gw_axes">
    <div
      v-if="hasX"
      class="gw_axes_axis gw_axes_axis_x"
      :class="{ gw_axes_axis_x_lines: hasLinesX }"
    >
      <slot name="legend_x"></slot>
      <div
        v-for="(t, idx) in XTicks"
        :key="`${t}_${idx}`"
        class="gw_axes_axis_tick"
        :style="
          idx === XTicks.length - 1
            ? 'justify-content:flex-end'
            : idx === 0
              ? 'justify-content:flex-start'
              : ''
        "
      >
        <div class="gw_axes_axis_tick_item">
          {{ t }}
        </div>
      </div>
    </div>
    <div
      v-if="hasY"
      class="gw_axes_axis gw_axes_axis_y"
      :class="[{ gw_axes_axis_y_line: hasLineY }]"
    >
      <slot name="legend_y"></slot>
      <div
        v-for="(t, idx) in YTicks"
        :key="`${t}_${idx}`"
        class="gw_axes_axis_tick"
        :class="{ gw_axes_axis_tick_line: hasLinesY }"
        :style="t.style || ''"
      >
        {{ t.value ?? t }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChartAxes',
  props: {
    XTicks: { default: () => [0, 25, 50, 75, 100] },
    YTicks: { default: () => [0, 25, 50, 75, 100] },
    hasX: { type: Boolean, default: true },
    hasY: { type: Boolean, default: true },
    hasLineY: { type: Boolean, default: true },
    hasLineX: { type: Boolean, default: true },
    hasLinesX: Boolean,
    hasLinesY: Boolean,
  },
}
</script>
<style lang="scss" scoped>
.gw_axes {
  --axis-space: 1rem;
  --axis-height: var(--axis-space);
  // --axis-position: 1rem;
  --tick-size: 0.7rem;
  --clr-axis: var(--clr-black-4);
  ---clr-axis-line-tick: var(--clr-black-4);

  --axis-x-width: 100%;
  --axis-x-inset: auto auto 0 0;
  --axis-y-height: 100%;
  --axis-y-width: auto;
  --axis-y-inset: 0 auto auto 0;

  --axis-y-align-items: center;
  --axis-y-justify-content: center;
  --axis-y-padding: 0;

  --axis-y-last-line-inset: auto auto auto auto;

  --axis-y-line-inset: auto auto auto auto;
  --axis-y-first-line-inset: auto auto 0 auto;
  --axis-y-last-line-inset: 0 auto auto auto;

  --first-tick-opacity: 0;
  --last-tick-opacity: 1;

  &_axis {
    display: flex;
    justify-content: space-between;
    position: absolute;
    // z-index: 2;
    z-index: 0;
    left: 0;
    &::before {
      content: '';
      background: var(--clr-axis);
      position: absolute;
    }
    &_tick {
      line-height: 1;
      font-size: var(--tick-size);
      width: var(--axis-space);
      max-width: var(--axis-space);
      color: var(--clr-axis);
      display: flex;
      position: relative;
      letter-spacing: -0.5px;
      pointer-events: none;
      &_item {
        position: absolute;
      }
      &:first-child {
        --axis-y-line-inset: var(--axis-y-first-line-inset);
        opacity: var(--first-tick-opacity);
      }
      &:last-child {
        --axis-y-line-inset: var(--axis-y-last-line-inset);
        opacity: var(--last-tick-opacity);
      }
    }
    &_y {
      flex-direction: column-reverse;
      height: var(--axis-y-height);
      inset: var(--axis-y-inset);
      width: var(--axis-y-width);
      &_line {
        &::before {
          height: 100%;
          width: 1px;
          right: 0;
        }
      }
      .gw_axes_axis_tick {
        height: var(--axis-height);
        left: -4px;
        align-items: var(--axis-y-align-items);
        justify-content: var(--axis-y-justify-content);
        padding: var(--axis-y-padding);
        &_line {
          &::before {
            content: '';
            background: var(--clr-axis-line-tick);
            position: absolute;
            inset: var(--axis-y-line-inset);
            height: 1px;
            width: 100vw;
            left: 100%;
          }
        }
      }
    }
    &_x {
      width: var(--axis-x-width);
      inset: var(--axis-x-inset);
      &::before {
        height: 1px;
        width: 100%;
      }
      .gw_axes_axis_tick {
        top: 4px;
        width: 0px;
        height: var(--axis-height);
        align-items: center;
        justify-content: center;
      }
    }
  }
}
</style>
